import onboardAssessmentDetailsLocale from './en.json'

const en = {
  onboardAssessmentDetails: onboardAssessmentDetailsLocale,
}

export default en
